import { HttpStatus } from '@nucleus/lib-http';
import { zCustom } from '@nucleus/lib-shape';
import { zKey } from '@nucleus/ncu-key-prefix';
import z from 'zod';
import { PublishableEngineSchema } from './PublishableEngine';

export const PublishableRedirectSchema = z.object({
  id: zKey.prefixedKey().readonly(),
  ownerId: PublishableEngineSchema.shape.ownerId,
  engineId: PublishableEngineSchema.shape.id,
  entityType: z.string().optional().readonly(),
  code: z.union([z.literal(HttpStatus.MovedPermanently), z.literal(HttpStatus.Found)]),
  destination: z.string(),
  enabled: z.boolean(),
  match: z.string(),
  priority: z.number(),
  createdAt: zCustom.iso(),
  createdBy: z.string(),
  updatedAt: zCustom.iso(),
  updatedBy: z.string(),
  archivedAt: zCustom.iso().optional(),
  archivedBy: z.string().optional(),
});
export type PublishableRedirect = z.infer<typeof PublishableRedirectSchema>;
